import React from 'react';
import { Helmet } from 'react-helmet-async';
import { Box, Typography, Grid, Container, Card, CardContent, Button } from '@mui/material';
import PhoneIcon from '@mui/icons-material/Phone';
import AnimatedSection from '../components/AnimatedSection';
import "@fontsource/playfair-display";
const bridalBanner = '/assets/bridal_banner.jpeg';

const makeupPackages = [
  {
    name: 'Basic Make Up',
    price: '₹8,000',
    items: ['Make Up', 'Hair Do', 'Saree Draping'],
    featured: false,
  },
  {
    name: 'Premium Bridal',
    price: '₹10,000',
    items: ['Advanced Make Up', 'Hair Do', 'Saree Draping'],
    featured: true,
  },
];

const mehandiOptions = [
  { name: 'Full Hands', price: '₹2,000' },
  { name: 'Front & Back', price: '₹4,000' },
  { name: 'Full Hands (Arabic)', price: '₹1,000' },
];

const preBridalPackages = [
  {
    name: 'Gold Package',
    price: '₹10,000',
    items: [
      'Pure Pearl Facial',
      'Face & Neck Detan',
      'Spa Pedicure',
      'Spa Manicure',
      'Full Hands Waxing',
      'Half Leg Waxing',
      'Full Body Scrub',
      'Conditioning Hair Wash',
      'Threading',
    ],
    featured: false,
  },
  {
    name: 'Premium Package',
    price: '₹15,000',
    items: [
      'Ultra Bright Facial',
      'Face & Neck Detan',
      'Full Hands Waxing',
      'Full Legs Waxing',
      'Under Arms Waxing',
      'Crystal Pedicure',
      'Crystal Manicure',
      'Smoothening Hair Spa',
      'Conditioning Hair Wash',
      'Full Body Detan Polishing',
      'Threading',
    ],
    featured: true,
  },
  {
    name: 'Platinum Package',
    price: '₹20,000',
    items: [
      '24 Carat Gold Signature Facial',
      'Face & Neck Diamond Detan Pack',
      'Full Body Wax',
      'Bomb Pedicure',
      'Bomb Manicure',
      'Classic Hair Spa',
      'Hair Wash',
      '5 Step Body Polishing',
    ],
    featured: false,
  },
];

export default function BridalPage() {
  return (
    <Box>
      <Helmet>
        <title>Best Bridal Makeup in Vizag | Splash Beauty Lounge</title>
        <meta name="description" content="Get flawless bridal makeup services in Vizag with expert artists at Splash Beauty Lounge. Book your wedding makeover today." />
        <meta name="keywords" content="bridal makeup Vizag, wedding makeup artist Vizag, bridal packages Vizag, HD makeup Vizag, airbrush makeup Vizag, bridal salon Vizag" />
      </Helmet>
      <Box
        sx={{
          position: 'relative',
          height: {
            xs: '60vh',
            sm: '55vh',
            md: '60vh',
            lg: '75vh'
          },
          overflow: 'hidden',
          backgroundColor: '#1a1a1a',
        }}
      >
        <Box
          sx={{
            position: 'absolute',
            inset: 0,
            backgroundImage: `url(${bridalBanner})`,
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            opacity: 0.7,
          }}
        />
        <Box
          sx={{
            position: 'absolute',
            inset: 0,
            background: 'linear-gradient(to bottom, rgba(0,0,0,0.4) 0%, rgba(0,0,0,0.7) 100%)',
          }}
        />
        <Box
          sx={{
            position: 'relative',
            zIndex: 1,
            height: '100%',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            textAlign: 'center',
            px: 3,
          }}
        >
          <Typography
            variant="h2"
            sx={{
              color: '#fff',
              fontFamily: '"Playfair Display", serif',
              fontSize: { xs: '2.5rem', md: '4rem' },
              mb: 2,
              textShadow: '0 2px 15px rgba(0,0,0,0.5)',
            }}
          >
            Bridal Services
          </Typography>
          <Typography
            sx={{
              fontFamily: '"Lato", sans-serif',
              color: 'rgba(255,255,255,0.95)',
              fontSize: { xs: '1rem', md: '1.2rem' },
              maxWidth: 600,
              lineHeight: 1.6,
            }}
          >
            Make your special day unforgettable with our expert bridal packages and luxury styling
          </Typography>
        </Box>
      </Box>

      <Container maxWidth="md" sx={{ py: 8 }}>
        {/* Bridal Makeup */}
        <AnimatedSection>
          <Typography
            variant="h4"
            sx={{
              fontFamily: '"Playfair Display", serif',
              color: '#FF0099',
              textAlign: 'center',
              mb: 4,
              fontSize: { xs: '1.5rem', md: '2rem' },
            }}
          >
            Bridal Makeup
          </Typography>
        </AnimatedSection>
        <Grid container spacing={3} justifyContent="center" sx={{ mb: 7 }}>
          {makeupPackages.map((pkg, i) => (
            <Grid item xs={12} sm={6} key={pkg.name}>
              <AnimatedSection delay={i * 0.15}>
                <Card
                  elevation={pkg.featured ? 6 : 1}
                  sx={{
                    borderRadius: 3,
                    border: pkg.featured ? '2px solid #FF0099' : '1px solid #eee',
                    backgroundColor: pkg.featured ? '#FF0099' : '#fff',
                    textAlign: 'center',
                    transition: 'transform 0.3s',
                    '&:hover': { transform: 'translateY(-4px)' },
                  }}
                >
                  <CardContent sx={{ p: 4 }}>
                    <Typography
                      sx={{
                        fontFamily: '"Lato", sans-serif',
                        fontSize: '1rem',
                        fontWeight: 700,
                        color: pkg.featured ? '#fff' : '#1a1a1a',
                        mb: 1,
                      }}
                    >
                      {pkg.name}
                    </Typography>
                    <Typography
                      sx={{
                        fontFamily: '"Playfair Display", serif',
                        fontSize: '2.2rem',
                        fontWeight: 800,
                        color: pkg.featured ? '#fff' : '#1a1a1a',
                        mb: 1.5,
                      }}
                    >
                      {pkg.price}
                    </Typography>
                    <Typography
                      sx={{
                        fontFamily: '"Lato", sans-serif',
                        fontSize: '0.85rem',
                        color: pkg.featured ? 'rgba(255,255,255,0.9)' : '#666',
                        lineHeight: 1.8,
                      }}
                    >
                      {pkg.items.join(' • ')}
                    </Typography>
                  </CardContent>
                </Card>
              </AnimatedSection>
            </Grid>
          ))}
        </Grid>

        {/* Mehandi */}
        <AnimatedSection>
          <Typography
            variant="h4"
            sx={{
              fontFamily: '"Playfair Display", serif',
              color: '#FF0099',
              textAlign: 'center',
              mb: 4,
              fontSize: { xs: '1.5rem', md: '2rem' },
            }}
          >
            Mehandi
          </Typography>
        </AnimatedSection>
        <Grid container spacing={3} justifyContent="center" sx={{ mb: 7 }}>
          {mehandiOptions.map((opt, i) => (
            <Grid item xs={12} sm={4} key={opt.name}>
              <AnimatedSection delay={i * 0.1}>
                <Box
                  sx={{
                    border: '1px solid #eee',
                    borderRadius: 2,
                    p: 3,
                    textAlign: 'center',
                    transition: 'box-shadow 0.3s',
                    '&:hover': { boxShadow: '0 4px 15px rgba(255,0,153,0.1)' },
                  }}
                >
                  <Typography
                    sx={{ fontFamily: '"Lato", sans-serif', fontWeight: 600, fontSize: '0.95rem', color: '#333', mb: 1 }}
                  >
                    {opt.name}
                  </Typography>
                  <Typography
                    sx={{ fontFamily: '"Playfair Display", serif', fontSize: '1.5rem', fontWeight: 700, color: '#FF0099' }}
                  >
                    {opt.price}
                  </Typography>
                </Box>
              </AnimatedSection>
            </Grid>
          ))}
        </Grid>

        {/* Pre-Bridal Packages */}
        <AnimatedSection>
          <Typography
            variant="h4"
            sx={{
              fontFamily: '"Playfair Display", serif',
              color: '#1a1a1a',
              textAlign: 'center',
              mb: 4,
              fontSize: { xs: '1.5rem', md: '2rem' },
            }}
          >
            Pre-Bridal Packages
          </Typography>
        </AnimatedSection>
        <Grid container spacing={3} justifyContent="center" sx={{ mb: 5 }}>
          {preBridalPackages.map((pkg, i) => (
            <Grid item xs={12} sm={6} md={4} key={pkg.name}>
              <AnimatedSection delay={i * 0.12}>
                <Card
                  elevation={pkg.featured ? 8 : 1}
                  sx={{
                    borderRadius: 3,
                    border: pkg.featured ? '2px solid #FF0099' : '1px solid #eee',
                    backgroundColor: pkg.featured ? '#FF0099' : '#fff',
                    height: '100%',
                    transition: 'transform 0.3s',
                    '&:hover': { transform: 'translateY(-4px)' },
                  }}
                >
                  <CardContent sx={{ p: 3 }}>
                    <Typography
                      sx={{
                        fontFamily: '"Lato", sans-serif',
                        fontSize: '1rem',
                        fontWeight: 700,
                        color: pkg.featured ? '#fff' : '#1a1a1a',
                        mb: 0.5,
                      }}
                    >
                      {pkg.name}
                    </Typography>
                    <Typography
                      sx={{
                        fontFamily: '"Playfair Display", serif',
                        fontSize: '1.8rem',
                        fontWeight: 800,
                        color: pkg.featured ? '#fff' : '#1a1a1a',
                        mb: 2,
                      }}
                    >
                      {pkg.price}
                    </Typography>
                    {pkg.items.map((item, j) => (
                      <Typography
                        key={j}
                        sx={{
                          fontFamily: '"Lato", sans-serif',
                          fontSize: '0.82rem',
                          color: pkg.featured ? 'rgba(255,255,255,0.9)' : '#555',
                          mb: 0.5,
                          lineHeight: 1.6,
                        }}
                      >
                        • {item}
                      </Typography>
                    ))}
                  </CardContent>
                </Card>
              </AnimatedSection>
            </Grid>
          ))}
        </Grid>

        <AnimatedSection>
          <Box sx={{ textAlign: 'center' }}>
            <Button
              component="a"
              href="tel:8977626223"
              variant="contained"
              startIcon={<PhoneIcon />}
              sx={{
                backgroundColor: '#FF0099',
                color: '#fff',
                borderRadius: '25px',
                px: 4,
                py: 1.3,
                fontSize: '0.95rem',
                fontWeight: 700,
                '&:hover': { backgroundColor: '#CC0077' },
                boxShadow: '0 4px 20px rgba(255,0,153,0.3)',
              }}
            >
              Book Bridal Consultation
            </Button>
          </Box>
        </AnimatedSection>
      </Container>
    </Box>
  );
}